import { theme } from "@theme";
import React from "react";
import type { Genre } from "@libs/types/models/client";
import LBox from "../LBox";
import LText from "../LText";
import LArtwork from "@components/LArtwork";
import LLink from "@components/LLink";
import { sanitizeHexColor } from "@utils/colors";
import { DJ_SETS_CATEGORY_ID } from "./djSetsCategory";

interface BrowseItemProps {
  index: number;
  genre: Genre;
}

const SMALL_HEIGHT = 88;
const BIG_HEIGHT = 140;

const BrowseItem = ({ genre, index }: BrowseItemProps) => {
  const isBig = index % 4 === 1 || index % 4 === 2;
  const isLeft = index % 2 === 0;
  const containerHeight = isBig ? BIG_HEIGHT : SMALL_HEIGHT;

  const BIG_IMAGE_HEIGHT = 128;
  const SMALL_IMAGE_HEIGHT = 90;

  const IMAGE_HEIGHT = isBig ? BIG_IMAGE_HEIGHT : SMALL_IMAGE_HEIGHT;
  const OFFSET = isBig ? 15 : 10;
  const BOTTOM_OFFSET = isBig ? OFFSET : 25;

  const safeBgColor = sanitizeHexColor(genre.primaryColour);
  const safeSecondaryColor = sanitizeHexColor(genre.secondaryColour);

  return (
    <LLink
      href={
        genre.id === DJ_SETS_CATEGORY_ID
          ? { pathname: `/(app)/(tabs)/explore/setlists` }
          : {
              pathname: `/(app)/(tabs)/explore/genre/[genreId]`,
              params: {
                genreId: genre.id,
                screenName: genre.name,
              },
            }
      }
      sentryEventName={`search_browse_item_${genre.id}`}
    >
      <LBox
        style={{
          flex: 1,
          height: containerHeight,
          minHeight: containerHeight,
          borderRadius: theme.borderRadii.s,
          marginBottom: theme.spacing.s3,
          marginRight: isLeft ? theme.spacing.s3 / 2 : 0,
          paddingLeft: theme.spacing.s1,
        }}
      >
        <LBox
          flex={1}
          overflow="hidden"
          borderRadius="s"
          style={{
            backgroundColor: safeBgColor,
          }}
        >
          <LBox alignSelf="flex-end" zIndex={10} width={"66%"} pr="s2" pt="s2">
            <LText
              variant="bodyM2"
              fontSize={14}
              lineHeight={18}
              textAlign="right"
              color="genreText"
            >
              {genre.name}
            </LText>
          </LBox>
          <LArtwork
            url={genre.image}
            imageSize="medium"
            size={IMAGE_HEIGHT}
            blurhash={genre.blurhash}
            style={{
              position: "absolute",
              left: -OFFSET,
              bottom: -BOTTOM_OFFSET,
              borderRadius: theme.borderRadii.s,
              overflow: "hidden",
              height: IMAGE_HEIGHT,
              width: IMAGE_HEIGHT,
              transform: [{ rotate: "25deg" }],
            }}
          />
        </LBox>

        <LBox
          position="absolute"
          style={{
            bottom: -3,
            left: 0,
            right: 0,
            top: 3,
            backgroundColor: safeSecondaryColor,
            zIndex: -1,
            borderRadius: theme.borderRadii.s,
          }}
        />
      </LBox>
    </LLink>
  );
};

export default BrowseItem;
